/**
 * @enum
 * @readonly
 */
export const ZoneType = Object.freeze({
  TEXT: 'text',
  IMAGE: 'image',
});

/**
 * @enum
 * @readonly
 */
export const InputContentType = Object.freeze({
  TEXT: 'text',
  FILE: 'url',
});

/**
 * @enum
 * @readonly
 */
export const ZoneTypeMap = Object.freeze({
  [ZoneType.TEXT]: InputContentType.TEXT,
  [ZoneType.IMAGE]: InputContentType.FILE,
});
